import React from 'react'
import { MicrositeSettings } from '@dustin-web/microsite-config'

export const MicrositeSettingsContext = React.createContext<MicrositeSettings | null>(null)
export const useMicrositeSettingsContext = () => {
  const context = React.useContext(MicrositeSettingsContext)

  if (!context) {
    throw new Error('useMicrositeSettingsContext must be used within a MicrositeSettingsContext')
  }

  return context
}
